<template>
  <div
    v-if="!dismissed"
    class="alert flex-col flex-sm-row flex-nowrap small justify-content-between align-items-center"
  >
    <span
      class="announcement-text text-start me-3 d-inline-flex align-items-center py-2"
    >
      <i class="bubble far fa-bell c-brand-color me-2"></i>
      {{ $t('STUDIO.TEXT.ENABLE_PUSH_NOTIFICATIONS') }}
    </span>
    <div
      class="buttons-container d-flex flex-row flex-nowrap pb-2 pb-sm-0 align-items-center"
    >
      <span
        class="c-brand-color px-4 py-3 pointer hover-darken"
        @click="dismiss"
      >
        {{ $t('STUDIO.BUTTON.DISMISS') }}
      </span>
      <div
        class="enable-btn bg-brand-color c-white px-4 py-3 pointer hover-darken"
        @click="optIn"
      >
        {{ $t('STUDIO.BUTTON.ENABLE_NOW') }}
      </div>
    </div>
  </div>
</template>

<script>
import { useStudioStore } from '@/stores';
import Cookies from 'js-cookie';

export default {
  name: 'PushNotificationsOptIn',
  computed: {
    target() {
      return this.announcement.open_in_new_tab ? '_blank' : '_self';
    },
  },
  data() {
    return {
      dismissed: true,
    };
  },
  methods: {
    async optIn() {
      const messaging = this.$firebase.messaging();
      try {
        const permission = await Notification.requestPermission();
        if (permission === 'granted') {
          const currentToken = await messaging.getToken({
            vapidKey: process.env.VUE_APP_FIREBASE_VAPID_KEY,
          });
          try {
            if (currentToken) {
              console.log('currentToken', currentToken);
              useStudioStore().addPushToken({
                studioURL: this.$studioURL,
                token: currentToken,
              });
              this.$notify({
                group: 'app',
                type: 'success',
                title: this.$t('NOTIFICATIONS.TITLE.SUCCESS'),
                text: this.$t(
                  'SETTINGS.NOTIFICATIONS.SUCCESSFULLY_REGISTERED_FOR_PUSH_NOTIFICATIONS'
                ),
              });
            }
            this.dismissed = true;
          } catch (error) {
            console.error(error);
            this.$notify({
              group: 'app',
              type: 'error',
              title: 'An error occurred while retrieving push token',
              text:
                'Check your browser settings and enable push notifications for this website, then try again.',
              duration: -1, // stay ON
            });
          }
        } else {
          this.$notify({
            group: 'app',
            type: 'error',
            title: 'An error occurred while retrieving push token',
            text:
              'Notification permissions were not granted. Please enable them in your browser settings and try again.',
            duration: -1, // stay ON
          });
        }
      } catch (error) {
        console.error(error);
        this.$notify({
          group: 'app',
          type: 'error',
          title: 'An error occurred while retrieving push token',
          text:
            'Check your browser settings and enable push notifications for this website then try again',
          duration: -1, // stay ON
        });
      }
    },
    dismiss() {
      const now = new Date();
      const exp = new Date(
        now.getFullYear(),
        now.getMonth() + 1,
        now.getDate()
      );
      Cookies.set('dismissedPush', true, { expires: exp });
      this.dismissed = true;
    },
  },
  mounted() {
    if (Cookies.get('dismissedPush')) {
      this.dismissed = true;
    } else {
      this.dismissed = false;
    }
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/components-variables.scss';

.alert {
  font-size: 0.875rem;
  display: flex;
  flex-direction: column;
  background-color: $white;
  border-radius: $border-radius;
  border-color: var(--brand-color, $coral);
  color: $charcoal;
  text-align: center;
  position: relative;
  padding: 0 0 0 1rem;

  .close {
    position: absolute;
    top: 10px;
    right: 10px;
    font-size: 14px;
    cursor: pointer;
  }
}

.bubble {
  background-color: var(--brand-color-with-opacity-03, $coral);
  border-radius: 50%;
  padding: 0.5rem;
  width: 32px;
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.hover-darken {
  &:hover {
    filter: brightness(90%);
  }
}

.enable-btn {
  @include media-breakpoint-only(xs) {
    border-radius: $border-radius;
  }
}
</style>
